export default __webpack_public_path__ + "87f256d6f6e5d0f1d614bee61258ae46.jpeg";